import styled from "styled-components";

export const FundingSection = styled.section`
    width: 100%;
    margin-top: 50px;
`;

export const FundingContent = styled.div`
    max-width: 1280px;
    margin: 0 auto;
`;